import React from "react";
import * as WidgetUtils from "./../client20/logic/WidgetUtils";

// Externals
import cn from "classnames";

// Component styles
import classes from "./FloatingLabel.module.scss";

export function FloatingLabel(props) {
  const { widgetId, hasContent, hasFocus, text } = props;

  return (
    <label
      htmlFor={widgetId}
      className={cn(classes.label, (hasContent || hasFocus) ? classes.move : "")}
    >
      {WidgetUtils.toCleanText(text).replace(":", "")}
    </label>
  );
}

export function FloatingLabelContainer(props) {
  return (
    props.condition
      ? (
        <div className={classes.container}>
          <FloatingLabel widgetId={props.widgetId} hasContent={props.hasContent} hasFocus={props.hasFocus} text={props.text} />
          {props.children}
        </div>
      )
      : props.children
  );
}